import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { GRADUATION } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/graduation/$id")({
  component: () => <DeptContentForm cfg={GRADUATION} id={Route.useParams().id} />,
});
